import { ECG_PLOT_WIDTH } from './ecg-plot-width.constant';
const MS_PER_COLUMN = 20;
const MV_PER_ROW = 0.1;
const EVERBEAT_WEBPAGE = 'https://everbeat.net/';
const MAX_ECG_DURATION = 30;
const SWEEP_SPEED = 1 / (MS_PER_COLUMN / 1000);
const TIME_SCALE = `${MS_PER_COLUMN}ms/division (sweep speed = ${SWEEP_SPEED}mm/s)`;
const EVERBEAT_WAVEFORM_DECREASE = 40;
const HOLTER_FILTER_FREQUENCY = 10;
const HOLTER_FILTER_RESONANCE = 0.1;

export { PIXELS_IN_PLOT_SECOND } from './pixels-in-plot-second.constant';
export {
  MS_PER_COLUMN,
  MV_PER_ROW,
  EVERBEAT_WEBPAGE,
  MAX_ECG_DURATION,
  EVERBEAT_WAVEFORM_DECREASE,
  SWEEP_SPEED,
  TIME_SCALE,
  HOLTER_FILTER_FREQUENCY,
  HOLTER_FILTER_RESONANCE,
};
export { ECG_PLOT_WIDTH };
